export const wishlist = {
  namespaced: true,
  state: () => ({
    wishItems: {},
  }),
  mutations: {
    addProduct(state, wishItem) {
      Object.assign(state.wishItems, wishItem);
    },
    removeProduct(state, id) {
      delete state.wishItems[id];
    },
    resetWishlist(state) {
      state.wishItems = {};
    }
  },
  actions: {
    addProduct({ commit }, wishItem) {
      commit("addProduct", wishItem);
    },
    removeProduct({ commit, getters }, id) {
      if (getters.productExistsInWishlist(id))
        commit("removeProduct", id);
    },
  },
  getters: {
    productExistsInWishlist: (state) => (id) => {
      return Object.hasOwn(state.wishItems, id);
    },
    getProductFromWishlist: (state) => (id) => {
      return state.wishItems[id] ?? null;
    },
  },
};
